// extracted by mini-css-extract-plugin
export default {"add":"CourseButton_add__TgCGm","pick":"CourseButton_pick__oWPzU"};